import {
  FONT_WEIGHT_STANDARD,
  gray300,
  MOON_750,
  MOON_950,
  primary,
  primaryBorder,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const HomePageContentHeader = styled.h1`
  font-weight: calc(${FONT_WEIGHT_STANDARD} * 6); // 600
  font-size: 24px;
  line-height: 32px;
  color: ${MOON_950};
`;
HomePageContentHeader.displayName = 'S.HomePageContentHeader';

export const HomePageSectionHeader = styled.div`
  color: ${MOON_750};
  font-family: Source Sans Pro;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 160% */
  margin-bottom: 10px;
  justify-content: left;
`;
HomePageSectionHeader.displayName = 'S.HomePageSectionHeader';

export const HomePageHeader = styled.div`
  display: flex;
  align-items: center;
`;
HomePageHeader.displayName = 'S.HomePageHeader';

export const HomePageButton = styled.div`
  display: flex;
  @media (max-width: 320px) {
    flex-direction: column;
  }
  align-items: center;
  margin-left: auto;
  margin-bottom: 10px;
  gap: 10px;
`;
HomePageButton.displayName = 'S.HomePageButton';

export const StartGuide = styled.div<{isMobile?: boolean; embedded?: boolean}>`
  padding: ${props => (props.isMobile ? '16px 16px' : '32px 32px')} 8px;
  max-width: 920px;
  background: white;
  ${p =>
    !p.embedded &&
    css`
      border: 1px solid ${gray300}; // TODO
    `}
  border-radius: 3px;

  h1 {
    font-weight: 600;
    font-size: ${props => (props.isMobile ? '24' : '30')}px;
    padding: 0;
    margin: 0;
    margin-bottom: 8px;
  }

  h2 {
    font-weight: 400;
    font-size: 16px;
    padding: 0;
    margin: 0;
    margin-bottom: 16px;
  }
`;
StartGuide.displayName = 'S.StartGuide';

export const StartGuideSectionHeader = styled.div<{
  active?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;

  div:first-child {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    padding-bottom: 2px;
    color: ${props => (props.active ? 'white' : `${primary}`)};
    background: ${props => (props.active ? `${primary}` : 'white')};
    border-radius: 20px;
    border: 1px solid ${primary};
  }

  div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    span {
      display: flex;
      font-weight: normal;
    }
  }
`;
StartGuideSectionHeader.displayName = 'S.StartGuideSectionHeader';

export const StartGuideSectionSubheader = styled.div`
  margin-bottom: 8px;
`;
StartGuideSectionSubheader.displayName = 'S.StartGuideSectionSubheader';

export const StartGuideSection = styled.div`
  img {
    width: 100%;
    border: 1px solid ${gray300};
    border-radius: 6px;
    transition: filter 0.1s linear;

    &:hover {
      filter: brightness(95%);
    }
  }
`;
StartGuideSection.displayName = 'S.StartGuideSection';

export const StartGuideSectionContainer = styled.div<{border?: boolean}>`
  margin-left: 14px;
  padding: 6px 0 24px 20px;

  & > div:first-child {
    position: relative;
    left: -32px;
    top: -6px;
  }

  ${props =>
    props.border &&
    css`
      border-left: 1px solid ${primaryBorder};
    `}
`;
StartGuideSectionContainer.displayName = 'S.StartGuideSectionContainer';
